import { h, Host } from "@stencil/core";
/**
 * The `ch-tabular-grid-settings` component represents a settings window for a grid component.
 */
export class ChTabularGridSettings {
    constructor() {
        this.grid = undefined;
        this.show = false;
    }
    /**
     * Event emitted when the close button of the settings window is clicked.
     */
    settingsCloseClicked;
    windowClosedHandler(eventInfo) {
        eventInfo.stopPropagation();
        this.show = false;
        this.settingsCloseClicked.emit();
    }
    render() {
        return (h(Host, { key: '2dd03960e83bffe2d24a4e58b9e5f1fc644cc7d5' }, h("ch-window", { key: '644a992718653ff00d21afccafd68ca6aad83285', modal: true, container: this.grid, caption: "Options", closeText: "Close", closeOnOutsideClick: true, closeOnEscape: true, allowDrag: "header", hidden: !this.show, exportparts: "mask,window,header,caption,close,main,footer" }, h("slot", { key: 'dc1099e466f3591e7ad14aea06f1699dc5399acf' }))));
    }
    static get is() { return "ch-tabular-grid-settings"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["tabular-grid-settings.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["tabular-grid-settings.css"]
        };
    }
    static get properties() {
        return {
            "grid": {
                "type": "unknown",
                "mutable": false,
                "complexType": {
                    "original": "HTMLChTabularGridElement",
                    "resolved": "HTMLChTabularGridElement",
                    "references": {
                        "HTMLChTabularGridElement": {
                            "location": "global",
                            "id": "global::HTMLChTabularGridElement"
                        }
                    }
                },
                "required": true,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The `HTMLChTabularGridElement` that the settings window is associated with."
                }
            },
            "show": {
                "type": "boolean",
                "mutable": true,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Indicates whether the settings window is currently shown or not."
                },
                "attribute": "show",
                "reflect": true,
                "defaultValue": "false"
            }
        };
    }
    static get events() {
        return [{
                "method": "settingsCloseClicked",
                "name": "settingsCloseClicked",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Event emitted when the close button of the settings window is clicked."
                },
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                }
            }];
    }
    static get listeners() {
        return [{
                "name": "windowClosed",
                "method": "windowClosedHandler",
                "target": undefined,
                "capture": false,
                "passive": false
            }];
    }
}
